export const makeCountConfig = (count: number) => ({
  count,
  formatter: (count: number) =>
    `${count} ${count === 1 ? "funding round" : "funding rounds"}`,
});
